import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { ApplicationContractUpdate, AuthorizationCheckRequired, eventBus, PmStore } from "@/state";

export interface Contract {
    id: string,
    active: string,
    name: string,
    sent_ts: string,
    signed_ts: string,
    status_id: string, 
    status: string,
    updated_ts: string,
}


const queryGetApplicationContracts = gql`
  query applicationContracts($organizationId: UUID!, $applicationId: UUID!) {
    applicationContracts(organizationId: $organizationId, applicationId: $applicationId) {
        id
        active
        name
        sent_ts
        signed_ts
        status_id
        status
        updated_ts
    }
  }
`;




const queryGetContract = gql`
  query contract($organizationId: UUID!, $contractId: UUID!) {
    contract(organizationId: $organizationId, contractId: $contractId) {
        id
        name
        status
        status_id
        content
        signed_ts
        is_lease
        active
    }
  }
`;



const queryGetContractRecipients = gql`
  query contractRecipients($organizationId: UUID!, $contractId: UUID!) {
    contractRecipients(organizationId: $organizationId, contractId: $contractId) {
        account_id
        account_name
        has_signed
        signature
        is_pm
    }
  }
`;



const mutationPmSignContract = gql`
  mutation pmSignContract($organizationId: UUID!, $contractId: UUID!, $signature: String!) {
    pmSignContract(organizationId: $organizationId, contractId: $contractId, signature: $signature) 
  }
`;




export function useContractActions() {
    const state = PmStore();
    const [apiGetApplicationContracts] = useLazyQuery(queryGetApplicationContracts);
    const [apiGetContract] = useLazyQuery(queryGetContract);
    const [apiGetContractRecipients] = useLazyQuery(queryGetContractRecipients);
    const [apiPmSignContract] = useMutation(mutationPmSignContract);





  async function GetApplicationContracts(applicationId: string): Promise<[Contract]> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiGetApplicationContracts({ variables: { organizationId, applicationId} }) as any;
      return result.data.applicationContracts as [Contract];
    }
    catch (err) {
      toast.error("Api Error, Unable to retrieve application contracts.");
    }
  }


  async function GetContract(contractId: string): Promise<Contract> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiGetContract({ variables: { organizationId, contractId} }) as any;
      return result.data.contract as Contract;
    }
    catch (err) {
      toast.error("Api Error, Unable to retrieve contract.");
    }
  }

  async function GetContractRecipients(contractId: string): Promise<[]> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiGetContractRecipients({ variables: { organizationId, contractId} }) as any;
      return result.data.contractRecipients as [];
    }
    catch (err) {
      toast.error("Api Error, Unable to retrieve contract recpients.");
    }
  }

  async function PmSignContract(contractId: string, signature: string): Promise<Boolean> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiPmSignContract({ variables: { organizationId, contractId} }) as any;
      if(result.data.pmSignContract === true) {
        eventBus.next({type: ApplicationContractUpdate });
        return true;
      }
      throw "Api Error";
    }
    catch (err) {
      toast.error("Api Error, Unable to sign contract.");
    }
   
  }

    
    
    return {
        GetApplicationContracts,
        GetContract,
        GetContractRecipients,
        PmSignContract
    };
}




